module.exports = __webpack_public_path__ + "media/images/thumb/missing-9a2f97cdaa72808bd12cdbae7e1456f2.png";